<header class="header">
  <div class="topper--nomidio"></div>

  <div class="content">

    <a class="logo" routerLink="/">
      <img alt="Nomidio" role="heading" src="/assets/default/nomidio/nomidio-blue-green-idaas.svg">
    </a>

    @if (showNavigation) {
      <nav class="navigation-button-list">
        @if (user.realms?.length > 1) {
          <app-realms-dropdown
            [realms]="user.realms"
            [currentRealm]="user.currentRealm"
            (realmChanged)="switchRealm($event)">
          </app-realms-dropdown>
        }
        <button
          title="Your profile"
          aria-label="Your profile"
          class="navigation-button icon--admin-profile"
          type="button"
          [attr.aria-selected]="isProfileManagementSelected"
          [routerLink]="['/admin/edit/account/', user.adminId]"
          >
        </button>
        <div class="separator" role="separator"></div>
        <button
          title="Log out"
          aria-label="Log out"
          class="navigation-button icon--log-out"
          type="button"
          (click)="logout()"
          >
        </button>
      </nav>
    }
  </div>
</header>
